/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillCreateAdditionalServiceItem
 */
export interface BillCreateAdditionalServiceItem {
    /**
     * 附加服务ID
     * @type {number}
     * @memberof BillCreateAdditionalServiceItem
     */
    additionalServiceId?: number;
    /**
     * 附加服务金额
     * @type {number}
     * @memberof BillCreateAdditionalServiceItem
     */
    amount?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof BillCreateAdditionalServiceItem
     */
    currencyCode?: string;
}

/**
 * Check if a given object implements the BillCreateAdditionalServiceItem interface.
 */
export function instanceOfBillCreateAdditionalServiceItem(value: object): value is BillCreateAdditionalServiceItem {
    return true;
}

export function BillCreateAdditionalServiceItemFromJSON(json: any): BillCreateAdditionalServiceItem {
    return BillCreateAdditionalServiceItemFromJSONTyped(json, false);
}

export function BillCreateAdditionalServiceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillCreateAdditionalServiceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalServiceId': json['additionalServiceId'] == null ? undefined : json['additionalServiceId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}

export function BillCreateAdditionalServiceItemToJSON(json: any): BillCreateAdditionalServiceItem {
    return BillCreateAdditionalServiceItemToJSONTyped(json, false);
}

export function BillCreateAdditionalServiceItemToJSONTyped(value?: BillCreateAdditionalServiceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additionalServiceId': value['additionalServiceId'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
    };
}

